import axiosInstance from "../axiosInterceptor";

export async function getCourseBySlug(universitySlug, courseSlug) {
    const response = await axiosInstance.get(`admin/course/getCourseByCourseSlug/${universitySlug}/${courseSlug}`);
    const data = response?.data;
    return data;
};